export default "__VITE_ASSET__e5b5e454__"